import React from "react";
import clsx from "clsx";

import CheckIcon from "@material-ui/icons/Check";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

interface StylesProps {
  backgroundColor: string;
  strokeColor: string;
}

const useStyles = makeStyles<Theme, StylesProps>((theme: Theme) =>
  createStyles({
    facilityIcon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 30,
      height: 17,
      border: "1px solid",
      borderColor: theme.palette.primary.main,
      borderRadius: 15
    },
    facilityIconInner: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 24,
      height: 11,
      border: "1px solid",
      borderColor: theme.palette.primary.main,
      borderRadius: 15
    },
    facilityCheckIcon: {
      display: "none",
      color: "white",
      fontSize: 13
    },
    facilityCheckIconShow: {
      display: "block"
    },
    selected: {
      backgroundColor: ({ backgroundColor }) => `#${backgroundColor}`,
      borderColor: ({ strokeColor }) => `#${strokeColor}`
    }
  })
);

export interface Props {
  selected: boolean;
  code: string;
  className?: string;
  backgroundColor: string;
  strokeColor: string;
}

const FacilityIcon = (props: Props) => {
  const { selected, className, backgroundColor, strokeColor } = props;
  const classes = useStyles({ backgroundColor, strokeColor });

  return (
    <>
      <div
        className={clsx(
          classes.facilityIcon,
          {
            [classes.selected]: selected
          },
          className
        )}
      >
        <span
          className={clsx(classes.facilityIconInner, {
            [classes.selectedInner]: selected
          })}
        >
          <CheckIcon
            className={clsx(classes.facilityCheckIcon, {
              [classes.facilityCheckIconShow]: selected
            })}
          />
        </span>
      </div>
    </>
  );
};

export default FacilityIcon;
